<div class="cwb-wrapper">
	<div class="cwb-header d-flex align-items-center justify-content-between mb-3">
		<div>
			<h1>Production Board</h1>
			<span class="week-label-text">{{ weekLabel }} — click any cell to log or edit leads</span>
		</div>
		<div class="week-nav d-flex align-items-center gap-2">
			<button class="btn btn-sm btn-outline-secondary" (click)="prevWeek()">
				<i class="ri-arrow-left-s-line"></i>
			</button>
			<span class="week-nav-label">Week {{ currentWeek }} / {{ currentYear }}</span>
			<button class="btn btn-sm btn-outline-secondary" (click)="nextWeek()">
				<i class="ri-arrow-right-s-line"></i>
			</button>
		</div>
	</div>

	<div class="row">
		<div class="col-lg-12">
			<div class="card">
				<div class="card-body">
					<!-- Loading -->
					<div *ngIf="loading" class="text-center py-5">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</div>

					<!-- Table -->
					<div *ngIf="!loading" class="table-responsive">
						<table class="table cwb-table">
							<thead>
								<tr>
									<th class="col-account">ACCOUNT</th>
									<th class="col-lead-cost">$/LEAD</th>
									<th class="col-ordered">ORDERED</th>
									<th *ngFor="let day of weekDays" class="col-day">{{ day.dayName }} {{ day.label }}</th>
									<th class="col-total">TOTAL</th>
									<th class="col-leads-done text-center">LEADS DONE</th>
									<th class="col-billable text-center">BILLABLE</th>
									<th class="col-replacements text-center">REPLACEMENTS</th>
									<th class="col-revenue">
										REVENUE <br />
										<span class="text-muted">REAL / EXPECTED</span>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let campaign of campaigns" [class.table-danger]="getTotal(campaign) > campaign.ordered">
									<!-- Account Name + Status -->
									<td class="col-account">
										<div class="account-name">{{ campaign.campaign_name }}</div>
										<div class="d-flex align-items-center gap-1">
											<span class="status-badge" [ngClass]="getStatusClass(campaign)">
												{{ getCampaignStatus(campaign) }}
											</span>
											<span class="remaining-text" *ngIf="campaign.remaining > 0"> {{ campaign.remaining }} remaining </span>
										</div>
									</td>
									<td class="col-lead-cost" (dblclick)="editLeadCost(campaign)">
										<span *ngIf="!campaign.isEditingLeadCost">{{ campaign.lead_cost ? "$" + campaign.lead_cost : "-" }}</span>
										<input *ngIf="campaign.isEditingLeadCost" type="number" class="form-control form-control-sm text-center" [(ngModel)]="campaign.tempLeadCost" (blur)="saveLeadCost(campaign)" (keyup.enter)="saveLeadCost(campaign)" autofocus />
									</td>
									<td class="col-ordered" (dblclick)="editOrdered(campaign)">
										<span *ngIf="!campaign.isEditingOrdered">{{ campaign.ordered || "-" }}</span>
										<input *ngIf="campaign.isEditingOrdered" type="number" class="form-control form-control-sm text-center" [(ngModel)]="campaign.tempOrdered" (blur)="saveOrdered(campaign)" (keyup.enter)="saveOrdered(campaign)" autofocus />
									</td>
									<td *ngFor="let day of weekDays" class="col-day">
										<div class="day-cell">
											<span class="counter-value">
												{{ campaign.days[day.date] }}
											</span>
										</div>
									</td>
									<td class="col-total">{{ getTotal(campaign) || "-" }}</td>
									<td class="col-leads-done text-center">{{ campaign.leads_done || "-" }}</td>
									<td class="col-billable text-center">{{ getBillable(campaign) }}</td>
									<td class="col-replacements text-center">{{ campaign.replacements || "-" }}</td>
									<td class="col-revenue" [class.text-success]="getRealRevenue(campaign) > 0">{{ getRealRevenue(campaign) > 0 ? "$" + (getRealRevenue(campaign) | number: "1.0-0") : "-" }} / {{ getExpectedRevenue(campaign) > 0 ? "$" + (getExpectedRevenue(campaign) | number: "1.0-0") : "-" }}</td>
								</tr>

								<tr *ngIf="campaigns.length === 0">
									<td [attr.colspan]="3 + weekDays.length + 5" class="text-center py-4 text-muted">No active campaigns found for this week.</td>
								</tr>
							</tbody>
							<tfoot>
								<tr class="pb-foot">
									<td colspan="3" class="pb-foot-lbl">TOTALS</td>

									<td *ngFor="let day of weekDays" class="pb-c text-center">
										<div class="pb-num pb-strong">{{ getDayTotal(day) }}</div>
										<div class="pb-acc-sub">{{ "$" + getDayRevenueTotal(day).toLocaleString() }}</div>
									</td>

									<td class="pb-c pb-num pb-strong text-center">{{ getWeekTotal() }}</td>
									<td class="pb-c pb-num pb-strong text-center">{{ getLeadsDoneTotal() }}</td>
									<td class="pb-c pb-num pb-strong text-center">{{ getBillableTotal() }}</td>
									<td class="pb-c pb-num pb-strong text-center">{{ getReplacementsTotal() }}</td>
									<td class="pb-rev pb-num text-center" style="color: #15803d; font-size: 14px">{{ "$" + getWeekRevenueTotal().toLocaleString() }} / {{ "$" + getWeekExpectedRevenueTotal().toLocaleString() }}</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

